import React, { useEffect, useRef } from 'react'

const Tooltip = ({ children, ...props }) => {
  const element = useRef()

  useEffect(() => {
    // Use vanilla tooltips if Bootstrap failed to load
    if (typeof bootstrap == 'undefined') {
      // Skip if title is something else Bootstrap supports, like a function
      if (typeof props.title != 'string') return

      const div = document.createElement('div')
      div.innerHTML = props.title
      const title = div.textContent.trim().replace(/\r/g, '')
      .split('\n').map(line => line.trim()).join('\n')
      .replace(/ +/g, ' ').replace(/\n{3,}/g, '\n\n')
      element.current.setAttribute('title', title)
      return
    }

    const tooltip = new bootstrap.Tooltip(element.current, props)
    return () => tooltip.dispose()
  }, [])

  return <span ref={element} tabIndex="0" role="button">{children}</span>
}

export default Tooltip
